module.exports = __webpack_public_path__ + "static/df48d9ad04d0cb82bd614fe8442a93b70afa01d3986877fee7889acf22d051b7-e9238d347991ae43f2d615c826249091.jpeg";